import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { NoticeDataAccessModule } from "@youm-front/notice/data-access";
import { AccountCamMicEffects } from "./effects";

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([AccountCamMicEffects]),
    NoticeDataAccessModule
  ]
})
export class AccountCammicFeatureAccountCammicModule {}
